import { createContext, useContext } from 'react';

export const RouterUrlContext = createContext();
export const useRouterUrlContext = () => useContext(RouterUrlContext);
